module.exports = __webpack_public_path__ + "media/images/arr_g-d4e64df3e1069df25de1e4118cc52752.svg";